import {FC} from 'react';

type Icon = {
    className?: string;
};

const LiveIcon: FC<Icon> = () => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            // fill-rule="evenodd"
            // clip-rule="evenodd"
            d="M18.0358 2.65568C21.3922 4.78568 23.5 8.57297 23.5 12.6237C23.5 16.6218 21.446 20.1824 18.0561 22.3433C17.5903 22.6401 16.9721 22.5032 16.6753 22.0375C16.3784 21.5718 16.5153 20.9536 16.981 20.6567C19.8079 18.8548 21.5 15.9216 21.5 12.6237C21.5 9.26161 19.7457 6.10955 16.9642 4.34433C16.4979 4.04841 16.3597 3.43049 16.6557 2.96418C16.9516 2.49787 17.5695 2.35975 18.0358 2.65568ZM7.34433 2.96418C7.64026 3.43049 7.50213 4.04841 7.03582 4.34433C4.19931 6.14443 2.5 9.08322 2.5 12.3881C2.5 15.7432 4.24698 18.8898 7.01898 20.6567C7.48469 20.9536 7.62158 21.5718 7.32472 22.0375C7.02786 22.5032 6.40966 22.6401 5.94395 22.3433C2.59905 20.2111 0.5 16.4304 0.5 12.3881C0.5 8.3816 2.56276 4.81427 5.96418 2.65568C6.43049 2.35975 7.0484 2.49787 7.34433 2.96418ZM8.75663 8.08774C9.12239 8.50155 9.08344 9.13351 8.66963 9.49927C6.77679 11.1723 6.77679 13.8277 8.66963 15.5007C9.08344 15.8665 9.12239 16.4985 8.75663 16.9123C8.39087 17.3261 7.7589 17.365 7.34509 16.9993C4.55164 14.5302 4.55164 10.4698 7.34509 8.00074C7.7589 7.63498 8.39087 7.67393 8.75663 8.08774ZM16.9123 8.00074C19.7057 10.4698 19.7057 14.5302 16.9123 16.9993C16.4985 17.365 15.8665 17.3261 15.5007 16.9123C15.135 16.4985 15.1739 15.8665 15.5877 15.5007C17.4806 13.8277 17.4806 11.1723 15.5877 9.49927C15.1739 9.13351 15.135 8.50155 15.5007 8.08774C15.8665 7.67393 16.4985 7.63498 16.9123 8.00074Z"
            fill="#C5CDF8"
        />
        <path
            // fill-rule="evenodd"
            // clip-rule="evenodd"
            d="M12 10.5C10.8954 10.5 10 11.3954 10 12.5C10 13.6046 10.8954 14.5 12 14.5C13.1046 14.5 14 13.6046 14 12.5C14 11.3954 13.1046 10.5 12 10.5Z"
            fill="#C5CDF8"
        />
    </svg>
);

export default LiveIcon;
